import { useTheme } from 'next-themes';
import type { ReactNode } from 'react';

import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
import { DesktopNavbar } from './desktop-navbar';
import * as styles from './index.css';
import { MobileNavbar } from './mobile-navbar';

const HappenedMark = () => (
  <svg width="24" height="24" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="hp-nav-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#6366F1" />
        <stop offset="1" stopColor="#4F46E5" />
      </linearGradient>
    </defs>
    <rect width="192" height="192" rx="44" fill="url(#hp-nav-bg)" />
    <rect x="50" y="48" width="22" height="96" rx="6" fill="#FFFFFF" />
    <rect x="120" y="48" width="22" height="96" rx="6" fill="#FFFFFF" />
    <rect x="64" y="85" width="64" height="22" rx="6" fill="#FFFFFF" />
    <circle cx="142" cy="50" r="13" fill="#34D399" stroke="url(#hp-nav-bg)" strokeWidth="5" />
  </svg>
);

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { resolvedTheme } = useTheme();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a href="/" rel="noreferrer" className={styles.affineLogo}>
            <HappenedMark />
          </a>
          <DesktopNavbar />
          <MobileNavbar />
        </div>
      )}

      {children}
    </div>
  );
};
